const styles = {
  ctgPaper: (theme) => ({
    maxWidth: "600px",
    border: "1px solid #E9EBEC",
    borderRadius: "4px",
    padding: "30px 30px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "350px"
    },
  }),
  ctgdf: (theme) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  }),
  ctgTextField: (theme) => ({
    width: "380px",
    [theme.breakpoints.down("sm")]: {
      width: "280px"
    },
  }),
  ctgMS: (theme) => ({
    width: "380px",
    [theme.breakpoints.down("sm")]: {
      width: "280px"
    },
  }),
  ctgBtn: (theme) => ({
    padding: "10px 50px",
  }),
}

export default styles;